export enum DataroomAccessType {
  InviteOnly,
  Restricted,
  WhiteList,
  OpenAccess,
}
